<!--Mobile Header-->
<fgb-page-header [pageTitle]="'account.details.page.title'" [backButtonLink]="'/'"></fgb-page-header>
<!--Sub Nav-->
<div class="container">
  <fgb-account-nav></fgb-account-nav>
</div>
<div class="container d-none d-lg-block">
  <div class="row">
    <div class="col-12 col-lg-6 order-lg-1 order-1">
      <h5 class="text-left mb-3 mt-lg-0 text-white">{{ 'account.member.card.title' | translate }}</h5>
      <fgb-member-card [showLogo]="true"></fgb-member-card>

      <a
        class="card bg-tertiary tm-widget text-white mt-4 w-100 mb-5 text-white"
        href="{{ 'tm.account.manager.link' | translate }}"
      >
        <h5 class="text-uppercase">{{ 'account.tm.widget.title' | translate }}</h5>
        <img [src]="'images/tm-logo.svg' | contentAssetImage" />
      </a>
    </div>
    <div class="col-12 col-lg-6 order-lg-2 order-2">
      <h5 class="text-left my-3 mt-lg-0 text-white">{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>

      <h5 class="my-3 pt-3 text-white">{{ 'questions.subheading' | translate }}</h5>
      <fgbcl-edit-questions></fgbcl-edit-questions>
    </div>
  </div>
</div>

<div class="container d-lg-none">
  <h5 class="my-3 text-white">{{ 'account.details.title' | translate }}</h5>
  <fgb-account-details></fgb-account-details>

  <h5 class="my-3 pt-3 text-white">{{ 'questions.subheading' | translate }}</h5>
  <fgbcl-edit-questions></fgbcl-edit-questions>

  <a class="card bg-tertiary tm-widget text-white mt-4 w-100 mb-5" href="{{ 'tm.account.manager.link' | translate }}">
    <h5 class="text-uppercase">{{ 'account.tm.widget.title' | translate }}</h5>
    <img [src]="'images/tm-logo.svg' | contentAssetImage" />
  </a>
</div>
